/**
 * Luxury Collage Section - Interactive Mobile Slider & Progress Handler
 */
(function () {
  function initCollageSection(container) {
    if (!container) return;
    var track = container.querySelector('.luxury-collage__track');
    if (!track) return;

    var prevBtn = container.querySelector('[data-nav="prev"]');
    var nextBtn = container.querySelector('[data-nav="next"]');
    var progressBar = container.querySelector('.luxury-collage__progress-bar');

    function updateControls() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) {
        if (prevBtn) prevBtn.disabled = true;
        if (nextBtn) nextBtn.disabled = true;
        if (progressBar) progressBar.style.transform = 'translateX(0%)';
        return;
      }

      var currentScroll = track.scrollLeft;
      if (prevBtn) prevBtn.disabled = currentScroll <= 2;
      if (nextBtn) nextBtn.disabled = currentScroll >= maxScroll - 2;

      if (progressBar) {
        var progress = Math.min(Math.max(currentScroll / maxScroll, 0), 1);
        // Thumb width is ~35%, so max translation is 100% / 35% - 1 ≈ 185%
        progressBar.style.transform = 'translateX(' + (progress * 185) + '%)';
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var card = track.querySelector('.luxury-collage__item');
        var scrollAmount = card ? (card.offsetWidth + 12) * 2 : track.clientWidth * 0.75;
        track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var card = track.querySelector('.luxury-collage__item');
        var scrollAmount = card ? (card.offsetWidth + 12) * 2 : track.clientWidth * 0.75;
        track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls, { passive: true });

    // Initial update
    updateControls();
  }

  function initAll() {
    var sections = document.querySelectorAll('.luxury-collage__wrapper');
    sections.forEach(initCollageSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify Theme Customizer re-initialization
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) {
      var wrapper = event.target.querySelector('.luxury-collage__wrapper');
      if (wrapper) initCollageSection(wrapper);
    }
  });
})();
